import React, { useState } from 'react';
import PageContainer from '../components/PageContainer';
import { FiCheck, FiUsers, FiLock, FiMessageSquare, FiTrendingUp } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const pollOptions = [
  { id: 'a', text: 'Wash My Hands', votes: 45 },
  { id: 'b', text: 'Sin City', votes: 32 },
  { id: 'c', text: 'Birthday', votes: 23 },
];

export default function Community() {
  const [voted, setVoted] = useState(false);
  const [selected, setSelected] = useState(null);

  const handleVote = (id) => {
    setSelected(id);
    setVoted(true);
  };

  return (
    <PageContainer title="The Official Club">
      
      {/* Intro */}
      <div className="text-center max-w-3xl mx-auto mb-16">
        <p className="subtitle-typewriter leading-relaxed text-xl">
          More than just fans, we are a community. Join the official club to get closer to the music.
        </p>
      </div>

      {/* VIP Poll Section */}
      <div className="glass-panel border-2 border-sun-yellow/40 p-8 mb-16 relative overflow-hidden">
        <div className="absolute top-0 right-0 p-4">
          <span className="bg-sun-yellow text-black text-[10px] font-bold uppercase px-3 py-1 rounded-bl-lg">Exclusive Poll</span>
        </div>
        
        <div className="flex items-center gap-3 mb-6">
          <SafeIcon icon={FiTrendingUp} className="text-sun-yellow w-6 h-6" />
          <h3 className="text-2xl font-display">Member's Choice</h3>
        </div>
        
        <p className="subtitle-typewriter mb-8">Which deep cut should be added to the acoustic set list next month?</p>
        
        <div className="space-y-4 max-w-xl">
          {pollOptions.map((opt) => (
            <button 
              key={opt.id}
              onClick={() => !voted && handleVote(opt.id)}
              disabled={voted}
              className={`w-full relative h-14 rounded-lg border overflow-hidden transition-all text-left ${
                voted 
                  ? opt.id === selected ? 'border-sun-yellow bg-sun-yellow/10' : 'border-white/5 bg-white/5'
                  : 'border-white/20 hover:border-sun-yellow bg-black/40'
              }`}
            >
              {voted && (
                <div 
                  className="absolute inset-y-0 left-0 bg-sun-yellow/20" 
                  style={{ width: `${opt.votes}%` }}
                />
              )}
              <div className="relative px-4 h-full flex items-center justify-between font-typewriter">
                <span>{opt.text}</span>
                {voted && <span className="font-bold text-sun-yellow">{opt.votes}%</span>}
              </div>
            </button>
          ))}
        </div>
        
        {voted && (
          <p className="mt-4 font-typewriter text-xs text-gray-500 italic">Thank you for voting, VIP! Results are updated live.</p>
        )}
      </div>

      {/* Tiers */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto mb-16">
        {/* Free Tier */}
        <div className="bg-grunge-gray border border-gray-700 rounded-2xl p-8 flex flex-col">
          <div className="mb-6">
            <h3 className="text-3xl font-display text-white mb-2">Digital Fan</h3>
            <p className="text-3xl font-bold text-sun-yellow mb-1">Free</p>
            <p className="subtitle-typewriter text-xs">Always free, always welcome.</p>
          </div>
          <ul className="space-y-4 mb-8 flex-grow">
            <li className="flex items-start gap-3 font-typewriter text-sm text-gray-400">
              <SafeIcon icon={FiCheck} className="text-sun-yellow mt-1 flex-shrink-0" />
              Access to public community forums
            </li>
            <li className="flex items-start gap-3 font-typewriter text-sm text-gray-400">
              <SafeIcon icon={FiCheck} className="text-sun-yellow mt-1 flex-shrink-0" />
              Monthly email newsletter
            </li>
          </ul>
          <button className="w-full bg-gray-700 text-white font-bold py-3 rounded-full hover:bg-gray-600 transition-colors uppercase text-sm">
            Join Free
          </button>
        </div>

        {/* Paid VIP Tier */}
        <div className="bg-gradient-to-b from-sun-yellow/20 to-grunge-gray border-2 border-sun-yellow rounded-2xl p-8 flex flex-col relative overflow-hidden">
          <div className="mb-6">
            <h3 className="text-3xl font-display text-sun-yellow mb-2">All-Access VIP</h3>
            <p className="text-3xl font-bold text-white mb-1">$49.99<span className="text-lg text-gray-400 font-normal">/year</span></p>
            <p className="subtitle-typewriter text-xs">The ultimate insider experience.</p>
          </div>
          <ul className="space-y-4 mb-8 flex-grow">
             <li className="flex items-start gap-3 font-typewriter text-sm text-white">
              <SafeIcon icon={FiCheck} className="text-sun-yellow mt-1 flex-shrink-0" />
              First access to pre-sale tickets
            </li>
            <li className="flex items-start gap-3 font-typewriter text-sm text-gray-300">
              <SafeIcon icon={FiCheck} className="text-sun-yellow mt-1 flex-shrink-0" />
              Vote in exclusive member polls
            </li>
            <li className="flex items-start gap-3 font-typewriter text-sm text-gray-300">
              <SafeIcon icon={FiCheck} className="text-sun-yellow mt-1 flex-shrink-0" />
              Private VIP forum & live chat
            </li>
          </ul>
          <button className="w-full bg-sun-yellow text-black font-bold py-3 rounded-full hover:bg-white transition-colors uppercase text-sm shadow-[0_0_15px_rgba(255,215,0,0.4)]">
            Upgrade to VIP
          </button>
        </div>
      </div>
    </PageContainer>
  );
}